import { useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate, useRevalidator } from "react-router-dom";
import { ColDef, GridReadyEvent } from "ag-grid-community";
import { DataGrid } from "../../Controls/DataGrid";
import { PageBar, ToolButton } from "../../Controls/PageBar";
import { ActionDropdown, ActionItem } from "../../Controls/ActionDropdown";
import { Staff } from "../../Data/ApiTypes";
import StaffInviteModal from "./AdminStaffListPageInviteModal";
import { DataEntitiesOperator, OperatorApi } from "../../shared/api/axios-client";

import { createApiService } from "../../shared/apiConfig";
import { useAtom } from "jotai";
import { authTokenAtom } from "../../Data/Atoms";
import { EnvelopePaper, CreditCard2Front, Gear, PencilSquare, BoxArrowUpRight } from "react-bootstrap-icons";
 
const operatorApi = createApiService(OperatorApi)
export function AdminOperatorListPage() {
    const nav = useNavigate();
    //const staff = useLoaderData() as Staff[];
    const [showInvite, setShowInvite] = useState(false);
    const [operators, setOperators] = useState<DataEntitiesOperator[]>([]);
    const [authToken, setAuthToken] = useAtom(authTokenAtom);

    const columns = useMemo<ColDef<DataEntitiesOperator>[]>(() => [
       
        { field: "operatorId", headerName: "#", type: "rightAligned", width: 100 },
        { 
            field: "name", 
            headerName: "Name",
            cellRenderer: (params: any) => (
                <span 
                    style={{ cursor: 'pointer', textDecoration: 'underline' }}
                    onClick={() => handleButtonClick(params.data)}
                >
                    {params.value}
                </span>
            )
        },
        { field: "hostName", headerName: "Hostname" },
        { field: "emailAddress", headerName: "Note" },
        { field: "phoneNumber", headerName: "Phone", valueFormatter: x => x.value || "" },
         {
            headerName: "",
            width: 80,
            sortable: false,
            filter: false,
            valueGetter: () => "", // Dummy value since we're using cellRenderer
            cellRenderer: (params: any) => {
                const actions: ActionItem[] = [
                    {
                        label: "Go",
                        icon: <BoxArrowUpRight className="icon-shift-up" size={14} />,
                        onClick: () => handleButtonClick(params.data)
                    },
                    {
                        label: "Features",
                        icon: <Gear className="icon-shift-up" size={14} />,
                        onClick: () => handleIntegrationClick(params.data)
                    },
                    {
                        label: "Billing",
                        icon: <CreditCard2Front className="icon-shift-up" size={14} />,
                        onClick: () => handleBillingClick(params.data)
                    },
                    {
                        label: "Edit",
                        icon: <PencilSquare className="icon-shift-up" size={14} />,
                        onClick: () => onRowClicked(params.data)
                    }
                ];

                return <ActionDropdown actions={actions} />;
            }
        }

    ], []);

    const onGridReady = (params: GridReadyEvent) => {
        params.api.sizeColumnsToFit();
    };
    const insertSubdomain = (url, subdomain) => {
        // Ensure subdomain ends with a dot, no leading dot
        subdomain = subdomain.replace(/^\.+|\.+$/g, '') + '.';
        return url.replace(/^(https?:\/\/)(.*)$/, (_, proto, rest) => {
            return proto + subdomain + rest;
        });
    }
    
    const handleButtonClick = (data: DataEntitiesOperator) => {
        const monitorUrl = import.meta.env.VITE_SPOT_SYNC_MONITOR!
        const hostname = data.hostName!;
        const tenantUrl = insertSubdomain(monitorUrl, hostname);
        const redirectUrl = encodeURIComponent(`/operator/facilities`);
        const encodedUrl = `${tenantUrl}/sso?redirectUrl=${redirectUrl}&accessToken=${authToken.accessToken}`;
        window.open(encodedUrl, '_blank');
    };
        
    const handleIntegrationClick = (data: DataEntitiesOperator) => {
        nav(`/admin/operators/${data.operatorId}/integrations`);
        
    };

    const handleBillingClick = (data: DataEntitiesOperator) => {
        nav(`/admin/operators/${data.operatorId}/billing`);
    };

    const onRowClicked = (data: DataEntitiesOperator) => {
        nav(`/admin/operators/${data.operatorId}`);
    };
    const addOperator = () => {
        nav(`/admin/operators/add`);
    };

    useState(() => {
        (async () => {
            const response = await operatorApi.list({
                
            });
            if (response.data) {
                setOperators(response.data.items!);
            }
        })();
    });

    return <Container fluid className="h-100">
        <StaffInviteModal
            show={showInvite}
            setShow={setShowInvite} />
        <Row className="h-100">
            <Col className="h-100" style={{ display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "max-content 1fr 5px" }}>
                <PageBar title="Operator">
                    <ToolButton onClick={() => addOperator() }>
                        <EnvelopePaper color="maroon" /> Add Operator
                    </ToolButton>
                </PageBar>
                <div style={{ height: "100%", width: "100%" }}>
                    <DataGrid
                        rowData={operators}
                        columnDefs={columns}
                        onGridReady={onGridReady}
                    />
                </div>
            </Col>
        </Row>
    </Container>;
}